export default __webpack_public_path__ + "static/media/TotemPrototype20.71bcf118.jpg";